<template>
    <div class="container-fluid py-4 px-4">

        <!-- Encabezado -->
        <div class="border border-1 rounded-3 p-3 mb-3 ">
            <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
                <i class="bi bi-gear-fill display-4 text-primary"></i>
                <div>
                    <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
                        HORARIOS
                    </p>
                    <p class="mb-0 tituloResaltado fs-4 fw-bold">
                        MANTENIMIENTO
                    </p>
                </div>
            </div>
        </div>

        <div class="row g-3">
            <!-- Formulario de horarios -->
            <div class="col-lg-4 col-md-12">
                <form @submit.prevent="GrabarEntrevista" class="border rounded-3 p-4 shadow-sm bg-white">
                    <h5 class="text-success mb-3 fw-bold">
                        <i class="bi bi-clock-fill me-2"></i>REGISTRAR HORARIO
                    </h5>

                    <div class="mb-3">
                        <label class="form-label tamaño">INICIO DE HORA LABORAL:</label>
                        <input required v-model="iniHora" type="time" step="1" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label tamaño">FIN DE HORA LABORAL:</label>
                        <input required v-model="finHora" type="time" step="1" class="form-control"
                            @input="validarHoraFin" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label tamaño">INICIO DE REFRIGERIO:</label>
                        <input required v-model="iniRefrigerio" type="time" step="1" class="form-control" />
                    </div>

                    <div class="mb-3">
                        <label class="form-label tamaño">FIN DE REFRIGERIO:</label>
                        <input required v-model="finRefrigerio" type="time" step="1" class="form-control" />
                    </div>

                    <div class="d-flex justify-content-center mt-3">
                        <button class="btn btn-success w-50">
                            <i class="bi bi-floppy me-2"></i>Guardar
                        </button>
                    </div>
                </form>
            </div>

            <!-- Tabla de horarios -->
            <div class="col-lg-8 col-md-12">
                <div class="border rounded-3 p-3 shadow-sm bg-white">
                    <div class="d-flex justify-content-end mb-3 flex-wrap">
                        <label class="me-2 align-self-center fw-semibold">Buscar:</label>
                        <input class="form-control w-50" type="text" placeholder="TIPO DE ENTREVISTA..."
                             @input="handleFilter" />
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered table-hover align-middle text-center">
                            <thead>
                                <tr class="bg-solimano-table text-white text-center tamaño2 text-nowrap">
                                    <th>ID</th>
                                    <th>ASISTENCIA</th>
                                    <th>ACCION</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!-- Spinner mientras se cargan los datos -->
                                <tr v-if="loading">
                                    <td colspan="5" class="text-center py-5">
                                        <div class="spinner-border text-primary" role="status"
                                            style="width: 3rem; height: 3rem;">
                                            <span class="visually-hidden">Cargando...</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-else v-for="post in paginatedData" :key="post.idHorario"
                                    class="tamaños text-nowrap align-middle">

                                    <td class="text-center fw-bold"><i class="text-success me-2"></i>{{ post.idHorario
                                    }}</td>
                                    <td class="text-center"><i
                                            class="bi bi-clock-history text-success  fs-6 me-2"></i>{{
                                                post.fecDescripcion }}</td>
                                    <td class="d-flex justify-content-center gap-2">
                                        <button v-b-modal.modal-center @click="HorarioXparametro(post.idHorario)"
                                            class="btn btn-success btn-sm btn-action">
                                            <i class="bi bi-pencil-square"></i>
                                        </button>

                                        <!-- Botón Eliminar -->
                                        <button class="btn btn-danger btn-sm btn-action">
                                            <i class="bi bi-trash-fill"></i>
                                        </button>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Modal -->
                    <b-modal id="modal-center" centered title="MODIFCAR HORARIO" @ok="ModificarHorario">

                        <div class="container-fluid">

                            <!-- INICIO DE HORA LABORAL -->
                            <div class="mb-3 d-flex flex-column flex-md-row align-items-md-center">
                                <label class="tamaño d-flex align-items-center gap-2">
                                    <i class="bi bi-clock text-success fs-6 me-2"></i>INICIO DE HORA LABORAL:
                                </label>
                                <input required v-model="editarIniAsistencia" type="time" step="1"
                                    class="form-control flex-grow-1" />
                            </div>

                            <!-- FIN DE HORA LABORAL -->
                            <div class="mb-3 d-flex flex-column flex-md-row align-items-md-center">
                                <label class="tamaño d-flex align-items-center gap-2">
                                    <i class="bi bi-clock-history text-danger fs-6 me-2"></i>FIN DE HORA LABORAL:
                                </label>
                                <input required v-model="editarFinAsitencia" type="time" step="1"
                                    class="form-control flex-grow-1" />
                            </div>

                            <!-- INICIO DE REFRIGERIO -->
                            <div class="mb-3 d-flex flex-column flex-md-row align-items-md-center">
                                <label class="tamaño d-flex align-items-center gap-2">
                                    <i class="bi bi-cup-straw text-warning fs-6 me-2"></i>INICIO DE REFRIGERIO:
                                </label>
                                <input required v-model="editarIniRefrigerio" type="time" step="1"
                                    class="form-control flex-grow-1" />
                            </div>

                            <!-- FIN DE REFRIGERIO -->
                            <div class="mb-3 d-flex flex-column flex-md-row align-items-md-center">
                                <label class="tamaño d-flex align-items-center gap-2">
                                    <i class="bi bi-cup-fill text-info fs-6 me-2"></i>FIN DE REFRIGERIO:
                                </label>
                                <input required v-model="editarFinRefrigerio" type="time" step="1"
                                    class="form-control flex-grow-1" />
                            </div>

                        </div>

                    </b-modal>


                    <!-- Paginación -->
                    <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">

                        <!-- Primera página -->
                        <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1"
                            :disabled="currentPage === 1">
                            <i class="bi bi-chevron-double-left"></i>
                        </button>

                        <!-- Retroceder -->
                        <button class="btn btn-outline-primary btn-sm" @click="currentPage--"
                            :disabled="currentPage === 1">
                            <i class="bi bi-chevron-left"></i>
                        </button>

                        <span class="pagination-info fw-bold">
                            Página {{ currentPage }} de {{ totalPages }}
                        </span>

                        <!-- Avanzar -->
                        <button class="btn btn-outline-primary btn-sm" @click="currentPage++"
                            :disabled="currentPage === totalPages">
                            <i class="bi bi-chevron-right"></i>
                        </button>

                        <!-- Última página -->
                        <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
                            :disabled="currentPage === totalPages">
                            <i class="bi bi-chevron-double-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    name: "SolimanoLogHorarios",

    data() {
        return {

            iniHora: "",
            finHora: "",
            iniRefrigerio: "",
            finRefrigerio: "",
            informacion: [],
            currentPage: 1,       // Página actual
            itemsPerPage: 5,
            loading: false,

            editarIdHorario: "",
            editarIniAsistencia: "",
            editarFinAsitencia: "",
            editarIniRefrigerio: "",
            editarFinRefrigerio: "",
            ubicacionActual: null,
            watchId: null,
        };
    },
    computed: {
        paginatedData() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.informacion.slice(start, end);
        },
        totalPages() {
            return Math.ceil(this.informacion.length / this.itemsPerPage);
        }
    },

    async mounted() {
        let depa = await this.axios.get("ParametroData/Parametro/350");
        this.departamento = depa.data;
    },
    created() {
        this.cambiarEstadoNavbar();
        this.getAttributes();
    },

    methods: {
        handleFilter() {
            this.loading = true; // mostrar spinner
            // Simular un pequeño delay para ver el spinner
            setTimeout(() => {
                this.loading = false;
            }, 800); // 0.8 segundos
        },

        validarHoraFin() {
            // Validar que la hora de fin no sea anterior a la hora de inicio
            if (this.finHora < this.iniHora) {
                this.finHora = this.iniHora;
            }
        },

        GrabarEntrevista() {
            console.log("no funciono perro");
            const from = {
                fecIniAsistencia: this.iniHora,
                fecFinAsistencia: this.finHora,
                fecIniRefrigerio: this.iniRefrigerio,
                fecFinRefrigerio: this.finRefrigerio,
            };
            console.log(from);
            this.axios
                .post(`Asistencia/RegistrarHorario`, from)
                .then((r) => {
                    console.log(r.data);

                    if (r.data) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se registró cambios",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                    this.getAttributes();
                })
                .catch((error) => {
                    Swal.fire({
                        icon: "error",
                        title: `${error.response.data}`,
                        text: "",
                        footer: "",
                    });
                });
        },

        getAttributes() {
            this.axios.get(`Asistencia/ListadoHorario`).then((r) => {
                console.log(r.data);
                this.informacion = r.data;
            });
        },

        ModificarHorario() {
            const from = {
                idHorario: this.editarIdHorario,
                fecIniAsistencia: this.editarIniAsistencia,
                fecFinAsistencia: this.editarFinAsitencia,
                fecIniRefrigerio: this.editarIniRefrigerio,
                fecFinRefrigerio: this.editarFinRefrigerio,
            };
            this.axios
                .put(`Asistencia/ModificarHorario`, from)
                .then((r) => {
                    console.log(r.data);
                    if (r.data) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "Se Realizó cambios",
                            showConfirmButton: false,
                            timer: 2500,
                        });
                        this.getAttributes();
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        icon: "error",
                        title: `${error.response.data}`,
                        text: "",
                        footer: "",
                    });
                });
        },

        HorarioXparametro(id) {
            this.editarIdHorario = id;
            this.axios
                .get(`Asistencia/ListarHorarioxid?idHorario=${id}`)
                .then((r) => {
                    console.log(r.data);
                    this.editarIniAsistencia = r.data[0].fecIniAsistencia;
                    this.editarFinAsitencia = r.data[0].fecFinAsistencia;
                    this.editarIniRefrigerio = r.data[0].fecIniRefrigerio;
                    this.editarFinRefrigerio = r.data[0].fecFinRefrigerio;
                });
        },
        cambiarEstadoNavbar() {
            // Acción directa para cambiar el estado del navbar a true
            this.$store.dispatch("acciones/CambioNavbar", true);
        },


    },
};
</script>

<style scoped>
.tamaño {
    font-size: 0.65rem;

    font-weight: 800;
    color: #002c5d;
}

.tamaños {
    font-size: 0.65rem;
}

.tamaño2 {
    font-size: 0.65rem;
    font-weight: 800;
}

.titulo {
    color: #0080c8;
    text-decoration: underline;
}

.bg-solimano {
    border-color: #0080c8;
    border-width: 2px;
}

.bg-solimano-table {
    background: #0080c8;
}

.btn-solimano {
    background: #0080c8;
}

.tituloColorMas {
    /* color: #002c5d; */
    font-weight: 500;
    text-decoration: none;
    font-size: 1.23rem;
}

.btn-action {
    transition: all 0.2s ease-in-out;
}

.btn-action:hover {
    filter: brightness(85%);
}

.btn-action:active {
    transform: scale(0.95);
    filter: brightness(75%);
}
.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
.reducirTamaño {
  font-size: 0.65rem;
}
</style>